import { render, staticRenderFns } from "./SegmentedButtonPair.vue?vue&type=template&id=5568c058&scoped=true"
import script from "./SegmentedButtonPair.vue?vue&type=script&lang=js"
export * from "./SegmentedButtonPair.vue?vue&type=script&lang=js"
import style0 from "./SegmentedButtonPair.vue?vue&type=style&index=0&id=5568c058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5568c058",
  null
  
)

export default component.exports